import React, { type FunctionComponent } from 'react'
import { LogOutIcon } from '@instacart/ids-core'
import { NavItem } from '../NavItem'

export const ContractorPortalNavFooterContent: FunctionComponent = () => (
  <React.Fragment>
    <NavItem title="app.admin.nav.links.logOut" route="log-out" Icon={LogOutIcon} />
  </React.Fragment>
)
